exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hdr {\n  height: 85px;\n  text-align: center;\n  line-height: 85px; }\n\ntd {\n  vertical-align: middle;\n  border-top: 1px solid transparent;\n  padding: 0.25rem; }\n  td:hover {\n    background: #fff; }\n\ntable tbody tr:first-child td {\n  border-top: 0; }\n\n.table.br thead th:first-child,\n.table.br tr td:first-child {\n  padding-left: 0 !important; }\n\n.table.br .break {\n  margin-top: 0;\n  text-align: right; }\n\n.table.br tr.active {\n  color: #54b4e6; }\n  .table.br tr.active .break {\n    color: #54b4e6; }\n\n.h46 {\n  height: 41px;\n  padding-top: 5px;\n  max-height: 46px;\n  min-height: 46px;\n  overflow: hidden;\n  line-height: 1.1rem;\n  vertical-align: middle;\n  display: table-cell;\n  float: right;\n  margin-right: 35px; }\n  .h46 :first-child {\n    border-top: 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/brds/widgets/data-cards/data-card-dates/data-card-dates.component.scss
// module id = ../../../../../src/app/brds/widgets/data-cards/data-card-dates/data-card-dates.component.scss
// module chunks = 10